import * as Yup from 'yup'

export const schema = (t: (key: string) => string) => ({
  supplierUuid: Yup.string().required(t('requiredMessage')),
})
